import { getCollection } from "@/api/inventory/getConfig";
import { BatchBurn } from "@/components/burn/BatchBurn";
import { ERC721ABurn } from "@/components/burn/ERC721ABurn";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/$collection/burn-nft")({
	loader: async ({ params, context }) => {
		const collection = await getCollection({
			queryClient: context.queryClient,
			collectionAddress: params.collection,
		});
		return collection;
	},
	component: BurnNFTComponent,
});

function BurnNFTComponent() {
	const collection = Route.useLoaderData();

	return collection.type === "ERC721A" ? (
		<ERC721ABurn collectionAddress={collection.address} />
	) : (
		<BatchBurn collectionAddress={collection.address} />
	);
}
